import React from "react";
import { Alert } from "reactstrap";

const ProgressIndicator = ({
  loading,
  currentStep,
  generatingSceneIndex,
  numScenes,
  generatingVideos,
  videoGenerationStep,
  videoProgress
}) => {
  if (loading) {
    return (
      <Alert color="info" className="mb-3">
        <div className="d-flex align-items-center">
          <i className="fa fa-spinner fa-spin me-2"></i>
          <div>
            <strong>{currentStep}</strong>
            {generatingSceneIndex >= 0 && (
              <div className="mt-1">
                <small>
                  Progress: {generatingSceneIndex + 1} of {numScenes} scenes
                </small>
              </div>
            )}
          </div>
        </div>
      </Alert>
    );
  }

  if (generatingVideos) {
    return (
      <div className="mt-3">
        <Alert color="primary">
          <div className="d-flex align-items-center">
            <i className="fa fa-cog fa-spin me-2"></i>
            <div className="flex-grow-1">
              <strong>{videoGenerationStep}</strong>
              {videoProgress.total > 0 && (
                <div className="mt-2">
                  <div className="progress" style={{ height: "8px" }}>
                    <div
                      className="progress-bar"
                      style={{
                        width: `${(videoProgress.current / videoProgress.total) * 100}%`,
                      }}
                    ></div>
                  </div>
                  <small className="text-muted mt-1 d-block">
                    Processing: {videoProgress.current} of {videoProgress.total} scenes
                  </small>
                </div>
              )}
            </div>
          </div>
        </Alert>
      </div>
    );
  }

  return null;
};

export default ProgressIndicator;